import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Url } from "../../config/config";
import { Modal, Col, Row, Tab, Nav } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import { Pdf, Jpg, Png, Jpeg } from "../../assets/icons";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { dateFormat } from "../../utils";

export default function UserDetails() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [user, setUser] = useState({});
  const [listing, setListing] = useState([]);
  const [iState, updateState] = useState({
    docId: "",
    action: "",
    partnerTypeValue: "",
    partnerValue: "",
  });

  const [errorField, setErrorField] = useState({
    partnerTypeValue: "",
    partnerValue: "",
  });

  const { docId, action } = iState;
  const { id } = useParams();

  //***************User Details************* /
  const handelUserDetails = async (search = "") => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/financialPartnerMgmt/details?partnerId=${id}&search=${search}`,
        method: "GET",
      });
      hideLoader();
      if (res.status === 200) {
        setUser(res.data.data);
        setListing(res.data.data.clientFinancedCompanyDetails[0].solarlisting);
      }
      console.log(res.data.data);
    } catch (err) {
      console.log(err);
    }
  }; 

  //**************Financed by Volt list*********
  const [partner, setPartner] = useState([]);
  const financedByParnerList = async () => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/financialPartnerMgmt/clientFinancedCompanyDetails?partnerId=${id}`,
        method: "GET",
      });
      hideLoader();
      if (res.status === 200) {
        setPartner(res.data.data.data);
      }
      console.log("detailsss ", res.data.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handelSearch = (e) => {
    handelUserDetails(e.target.value);
  };

  useEffect(() => {
    handelUserDetails();
    financedByParnerList();
  }, []);

  return (
    <React.Fragment>
      <title>Financial Partner Details</title>
      <div className="WrapperArea view_details_page">
        <div className="WrapperBox">
          {loader}
          <div className="Small-Wrapper">
            <h4 className="Title back_wrap">
              {" "}
              <Link to="/financial-partner" className="back_btn">
                <i className="fa fa-arrow-left"></i>
              </Link>
              User Details
            </h4>
            <div className="OrderArea">
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Row>
                  <Col sm={2}>
                    <Nav variant="pills" className="flex-column">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Personal Details</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">
                          Client Financed Company Details
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                  <Col sm={10}>
                    <Tab.Content>
                      <Tab.Pane eventKey="first">
                        <ul>
                          <li>
                            <b>Finance Company Type</b>{" "}
                            <span>
                              {user.details
                                ? user.details[0].financeCompanyType
                                : ""}
                            </span>
                          </li>
                          <li>
                            <b>Finance Company Name</b>{" "}
                            <span>
                              {user.details
                                ? user.details[0].financeCompanyName
                                : ""}
                            </span>
                          </li>
                          <li>
                            <b>Company Email</b>{" "}
                            <span>
                              {user.details ? user.details[0].email : ""}
                            </span>
                          </li>

                          <li>
                            <b>Company Phone Number</b>{" "}
                            <span>
                              {user.details ? user.details[0].contactNum : ""}
                            </span>
                          </li>
                          <li>
                            <b>Contact Person Name</b>{" "}
                            <span>
                              {user.details
                                ? user.details[0].contactPersonName
                                : ""}
                            </span>
                          </li>

                          <li>
                            <b>Company Address</b>{" "}
                            <span>
                              {user.details ? user.details[0].address : ""}
                            </span>
                          </li>

                          <li>
                            <b>City</b>{" "}
                            <span>
                              {user.details ? user.details[0].city : ""}
                            </span>
                          </li>
                          <li>
                            <b>State</b>{" "}
                            <span>
                              {user.details ? user.details[0].state : ""}
                            </span>
                          </li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <div className="SearchBox">
                          <input
                            type="text"
                            placeholder="Search"
                            onChange={(e) => {
                              handelSearch(e);
                            }}
                          />
                        </div>
                        <div className="TableList">
                          {loader}
                          <table>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Company Name</th>
                                <th>Email</th>
                                <th>Contact Number</th>
                                <th>State</th>
                                <th>Request Date</th>
                                {/* <th>Status</th> */}
                                <th>View</th>
                              </tr>
                            </thead>
                            <tbody>
                              {partner &&
                                partner.length > 0 &&
                                partner.map((item, i) => (
                                  <tr key={i}>
                                    <td>{++i}</td>
                                    <td>{item.nameOfBusiness}</td>
                                    <td></td>
                                    <td>{item.contactNum}</td>
                                    <td>{item.state}</td>
                                    <td>{dateFormat(item.createdAt)}</td>
                                    {/* <td>
                                      <span className="accept">
                                        {item.financePartnerState &&
                                        item.financePartnerState.length > 0
                                          ? item.financePartnerState[0].status
                                          : "- - -"}
                                      </span>
                                    </td> */}
                                    <td>
                                      <Link to={`/user/details/${item.userId}`}>
                                        <i className="fa fa-eye"></i>
                                      </Link>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
